import { getProducts } from './productsHelper';
import { ProductsCategory } from '../../config';
const products = getProducts();

const cacluclateSubTotal = (items) => {
  let subTotal = 0;
  for (let item of items) {
    const product = products[item.key];
    let price;
    if (item.isSubscription) {
      if (product?.initialPrice != 0) {
        price = product.initialPrice;
      } else if (product?.recurringPrice) {
        price = product.recurringPrice;
      } else {
        price = product?.single_price;
      }
    } else {
      price = product?.single_price;
    }

    subTotal += item.quantity * (price || 0);
  }

  return parseFloat(subTotal).toFixed(2);
};

export { cacluclateSubTotal };
